import {
  AfterViewChecked,
  Directive,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { concat, fromEvent, merge, of, Subscription } from 'rxjs';
import { share, tap } from 'rxjs/operators';
import { ContentService } from '../core/content.service';
import { EventsService } from '../core/events.service';

@Directive({ selector: '[followScroll]' })
export class FollowScrollDirective
  implements OnInit, OnDestroy, AfterViewChecked
{
  constructor(
    private readonly contentService: ContentService,
    private readonly eventsService: EventsService,
    private readonly renderer: Renderer2,
    private readonly element: ElementRef<HTMLElement>,
  ) {}

  readonly scroll = concat(
    of(undefined),
    merge(
      this.eventsService.resize,
      this.contentService.observe(this.element.nativeElement),
      fromEvent(this.element.nativeElement, 'scroll'),
    ).pipe(
      share(),
      tap(
        () =>
          (this.following =
            this.element.nativeElement.scrollHeight -
              this.element.nativeElement.offsetHeight -
              this.element.nativeElement.scrollTop ==
            0),
      ),
    ),
  );

  following: boolean;

  scrollSub: Subscription;

  ngOnDestroy() {
    this.scrollSub.unsubscribe();
  }

  ngOnInit() {
    this.scrollSub = this.scroll.subscribe();
  }

  ngAfterViewChecked() {
    if (this.following) {
      this.renderer.setProperty(
        this.element.nativeElement,
        'scrollTop',
        this.element.nativeElement.scrollHeight,
      );
    }
  }
}
